import constant from '../../constant';
import { setData, getData } from '../../../utils/yUtil';

const showSysDialog = (params) => {
  const { cancle, primary, status } = params;

  return {
    type: constant.DIALOG.SYS_DIALOG,
    sysDialogStatus: status,
    primary,
    cancle
  }
}

const showWelfareDialog = (status = false) => {
  return {
    type: constant.DIALOG.WELFARE_DIALOG,
    welfareDialogStatus: status
  }
}

const showSmpDialog = (params = {}) => {
  const { cancle, primary, smpDialogStatus } = params;

  return {
    type: constant.DIALOG.SMP_DIALOG,
    smpDialogStatus,
    primary,
    cancle
  }
}


const setContentCollapsed = (contentCollapsed) => {
  return {
    type: constant.DIALOG.COLLAPSED,
    contentCollapsed
  }
}


const showSysDialogActiveApp = (status = false) => {
  return {
    type: constant.DIALOG.SYS_DIALOG_ACTIVE_APP,
    sysDialogActiveAppStatus: status
  }
}


const showCancelInstallDialog = (params = {}) => {
  let welfareDialogStatus = false
  let defaultDialogStatus = false
  // 以后根据smp实验数据在这里区分展示哪个弹窗---目前只需要展示内容弹窗

  if(params.status === 2) {
    // 优先判断是否已经展示过，后续增加过期时间比较好
    const value = getData('cancel_install_default_dialog')
    
    if(value) {
      defaultDialogStatus = false
    } else {
      defaultDialogStatus = true
      setData('cancel_install_default_dialog', true)
    }
    
    // const value = getData('cancel_install_welfare_dialog')
    // console.log('cancel_install_welfare_dialog', value)
    // if(value) {
    //   welfareDialogStatus = false
    // } else {
    //   welfareDialogStatus = true
    //   setData('cancel_install_welfare_dialog', true)
    // }
  }

  return {
    type: constant.DIALOG.CANCEL_INSTALL_DIALOG,
    cancelInstallWelfareDialogStatus: welfareDialogStatus,
    cancelInstallDefaultDialogStatus: defaultDialogStatus
  }
}


export default {
  showSysDialog,
  showWelfareDialog,
  setContentCollapsed,
  showSysDialogActiveApp,
  showCancelInstallDialog,
  showSmpDialog
}